// web/src/screens/intro.ts — UI-04 (v3.2).
//
// Full-bleed theme-color background. Shows "SPĒLE NR. {N}" (the picker
// ordinal) + the game's authored title.
//
// v3.2 (migration 0038): the title used to be hardcoded per game in this
// file (`TITLE_FOR`). It now comes from the picker — which receives it
// from /api/games — via sessionStorage. The game number stays a
// per-shortcode mapping for now because /api/games doesn't return the
// picker sequence directly; if the user starts assigning sequence in
// the admin, this map can come from /api/games too.
//
// Motion 12.x vanilla animate() fades the section in on mount.

import { animateMini as animate } from "motion";
import { navigate } from "../main.js";

// Picker ordinal lookup — kept until /api/games starts returning sequence.
const NUMBER_FOR: Record<string, number> = {
  "vocab": 1,
  "first_sound": 2,
  "reading": 3,
  "letter_sound": 4,
  "missing_letter": 5,
};

export function mount(root: HTMLElement, props?: unknown): () => void {
  const p = (props ?? {}) as { gameShortCode?: string };
  const gameShortCode = p.gameShortCode ?? "vocab";
  document.body.className = `theme-${gameShortCode}`;

  const sess = JSON.parse(sessionStorage.getItem("currentSession") ?? "{}") as {
    sessionId?: string;
    gameTitle?: string;
  };
  const sessionId: string = sess.sessionId ?? "";
  const num = NUMBER_FOR[gameShortCode] ?? 1;
  const title = sess.gameTitle ?? "";

  root.innerHTML = `
    <section
      id="screen-intro-section"
      class="screen-intro"
      style="opacity: 0; min-height: 100dvh; background: var(--theme-color); color: var(--text-on-color); display: flex; flex-direction: column; align-items: center; justify-content: center; gap: var(--space-2xl); padding: var(--space-lg); cursor: pointer;"
    >
      <h1 style="font-family: var(--font-fancy); font-size: var(--type-display); font-weight: 400; line-height: 1.1; margin: 0; text-align: center; letter-spacing: 0.02em;">
        SPĒLE NR. ${num}
      </h1>
      <p style="font-family: var(--font-fancy); font-size: var(--type-heading); margin: 0; opacity: 0.92; text-align: center;">
      </p>
    </section>
  `;

  // Inject the title via textContent (T-11-09: never raw-HTML user/server data).
  const titleEl = root.querySelector("p")!;
  titleEl.textContent = title;

  const screen = root.querySelector("section")!;

  void animate("#screen-intro-section", { opacity: [0, 1] }, { duration: 0.3, ease: "easeOut" });

  function advance() {
    if (sessionId) {
      navigate(`/play/${encodeURIComponent(sessionId)}`);
    } else {
      navigate("/picker");
    }
  }

  const t = window.setTimeout(advance, 2000);

  function onTap() {
    window.clearTimeout(t);
    advance();
  }

  screen.addEventListener("click", onTap, { once: true });

  return () => {
    window.clearTimeout(t);
    screen.removeEventListener("click", onTap);
  };
}
